(() => {
  const representatives = new Map();
  function randomize(scope = document) {
    scope.querySelectorAll('[data-random-products]').forEach(preview => {
      if (preview.dataset.randomInitialized) return;
      const choices = [...preview.querySelectorAll('[data-product-preview-choice]')];
      if (!choices.length) return;
      const key = preview.dataset.designKey;
      if (!representatives.has(key)) {
        const selected = choices[Math.floor(Math.random() * choices.length)];
        representatives.set(key, { image: selected.dataset.image, title: selected.dataset.title });
      }
      const chosen = representatives.get(key);
      const img = preview.querySelector('img');
      img.src = chosen.image;
      img.alt = chosen.title;
      preview.dataset.randomInitialized = 'true';
    });
  }
  function init(root) {
    if (root.dataset.designInitialized) return;
    root.dataset.designInitialized = 'true';
    const families = [...root.querySelectorAll('[data-design-family]')];
    const search = root.querySelector('[data-design-search]');
    const filters = [...root.querySelectorAll('[data-design-filter]')];
    let kind = 'all';
    let syncing = false;
    root.querySelector('[data-design-tools]').hidden = false;
    function filter() {
      const term = search.value.trim().toLocaleLowerCase();
      let count = 0;
      families.forEach(family => {
        family.hidden = (kind !== 'all' && family.dataset.kind !== kind) || !family.dataset.search.toLocaleLowerCase().includes(term);
        if (!family.hidden) count++;
      });
      root.querySelector('[data-design-count]').textContent = `${count} ${count === 1 ? 'design' : 'designs'}`;
      root.querySelector('[data-design-empty]').hidden = count !== 0 || root.classList.contains('has-open');
    }
    function select(id, updateHistory = false, focus = false) {
      const selected = families.find(family => family.id === id);
      syncing = true;
      families.forEach(family => {
        family.open = family === selected;
        if (family === selected) family.hidden = false;
      });
      root.classList.toggle('has-open', Boolean(selected));
      if (!selected) filter();
      root.querySelector('[data-design-empty]').hidden = Boolean(selected) || families.some(family => !family.hidden);
      if (updateHistory) {
        const url = new URL(location.href);
        url.hash = selected ? selected.id : '';
        history.pushState(null, '', url);
      }
      if (focus && selected) {
        selected.querySelector('h2').focus({ preventScroll: true });
        root.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
      // Native toggle events are queued, so handlers compare the final state.
      syncing = false;
    }
    families.forEach(family => family.addEventListener('toggle', () => {
      if (syncing) return;
      const current = location.hash.slice(1);
      if (family.open && current !== family.id) select(family.id, true, true);
      else if (!family.open && current === family.id) select('', true);
    }));
    filters.forEach(button => button.addEventListener('click', () => {
      kind = button.dataset.designFilter;
      filters.forEach(filterButton => {
        const active = button === filterButton;
        filterButton.classList.toggle('is-active', active);
        filterButton.setAttribute('aria-pressed', String(active));
      });
      filter();
    }));
    search.addEventListener('input', filter);
    const fromHash = () => select(location.hash.slice(1));
    window.addEventListener('hashchange', fromHash);
    window.addEventListener('popstate', fromHash);
    filter();
    fromHash();
  }
  randomize();
  document.querySelectorAll('[data-design-shop]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    randomize(event.target);
    event.target.querySelectorAll('[data-design-shop]').forEach(init);
  });
})();
